import { injectable } from 'inversify';

import type { GetProductSetContentResponse } from './ownable.dtos';
import { GetProductSetContent } from './ownable.dtos';
import ServiceStackGateway from './service-stack';

@injectable()
export class ProductSetsAPI {
  get = async (id: number) => {
    const request = new GetProductSetContent();
    request.productSetId = id;

    const response =
      await ServiceStackGateway.get<GetProductSetContentResponse>(request);

    if (!response.success) {
      throw new Error(
        response.errors?.[0].userMessage ??
          `Unknown Error fetching Product Set content with id ${id}`
      );
    }

    return response.productSet;
  };
}
